module.exports = __webpack_public_path__ + "media/images/lp/industries/mv_taxi-41b2bf75817ebf7498a5359d0fdda565.png";